import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import { Specialty } from '../../../../domain/entities';
import { formatDate, formatTime } from '../../../../utils/dates';

interface Props {
  isOpen: boolean;
  date: Date;
  doctorName: string;
  specialty: Specialty | undefined;
  onClosedClicked: () => void;
  onConfirmClicked: () => void;
}

const ConfirmAppointmentDialog = ({
  isOpen,
  date,
  doctorName,
  specialty,
  onClosedClicked,
  onConfirmClicked
}: Props) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClosedClicked}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>¿Está seguro que desea confirmar la cita?</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          La cita será generada para el día <b>{formatDate(date)}</b> a las{' '}
          <b>{formatTime(date)}</b> con el doctor/a <b>{doctorName}</b> en la especialidad de{' '}
          <span style={{ color: specialty?.color }}>
            <b>{specialty?.name}</b>
          </span>
          .
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClosedClicked} color='error'>
          Cancelar
        </Button>
        <Button variant='outlined' onClick={onConfirmClicked} autoFocus>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmAppointmentDialog;
